export enum MFileUploadState {
  idle = 'Idle',
  uploading = 'Uploading',
  uploaded = 'Uploaded',
  error = 'error'
}
